import React, { Component } from "react";
import Classes from "./Panel.module.css";
class Panel extends Component {
  render() {
    return (
      <div className={Classes.panel} style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}

export default Panel;
